import { createContext, useContext, useState, useCallback, useRef, ReactNode } from 'react'

interface ToastContextType {
  show: (msg: string) => void
}

const ToastContext = createContext<ToastContextType>({ show: () => {} })

export function ToastProvider({ children }: { children: ReactNode }) {
  const [msg, setMsg] = useState<string | null>(null)
  const timerRef = useRef<number | null>(null)

  const show = useCallback((text: string) => {
    if (timerRef.current) window.clearTimeout(timerRef.current)
    setMsg(text)
    timerRef.current = window.setTimeout(() => setMsg(null), 2500)
  }, [])

  return (
    <ToastContext.Provider value={{ show }}>
      {children}
      {msg && <div className="toast">{msg}</div>}
    </ToastContext.Provider>
  )
}

export function useToast() {
  return useContext(ToastContext)
}
